<template>
  <v-container class="px-0 mx-0">
    <v-layout justify-end>
      <v-btn @click="exportExcel" width="150" :loading="loading" class="light--text text-capitalize btn_fnt" color="primary"> <v-icon small class="me-2">mdi-export</v-icon>Export </v-btn>
    </v-layout>
    <div v-show="false">
      <v-data-table id="exportRefund" :mobile-breakpoint="0" :headers="headers" :items="refunds" hide-default-footer class="elevation-1">
        <template v-slot:item.customerId="{ item }">
          {{ item.customer.customerId }}
        </template>
        <template v-slot:item.phone="{ item }">
          {{ item.user.phone }}
        </template>
        <template v-slot:item.name="{ item }"> {{ item.user.firstnameEn }} {{ item.user.lastnameEn }} </template>
        <template v-slot:item.amount="{ item }">
          {{ numberWithCommas(item.amount) }}
        </template>
        <template v-slot:item.updatedBy="{ item }">
          <span v-if="item.updatedBy">{{ item.updatedBy.firstnameEn }} {{ item.updatedBy.lastnameEn }}</span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
export default {
  props: {
    refunds: {
      required: true,
    },
    headers: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      options: {
        itemsPerPage: 25,
        page: 1,
      },
    };
  },
  created() {},

  methods: {
    exportExcel() {
      this.loading = true;
      Utils.htmlToExcel("exportRefund", "Refund", false);

      this.loading = false;
    },
  },
};
</script>
